module.exports = __webpack_public_path__ + "img/NukedTV-Web_29.92b3c460.png";